import { useState } from "react";

//Common
import {
  fn_getMesAnoAtual,
  fn_loadOpcoesMeses,
  fn_validarMesAno,
} from "@/common/utils/date";

//Util
import { ICONES_SETA } from "@/frontend/utils/icones";

/*
 * Seletor de mês/ano: o ano no topo (setas para o anterior e o próximo) e os 12 meses para escolher.
 * Apresentado pelo UInputMask no campo mês/ano (tipoMask "mesano" com showCalendario), na mesma janela do calendário da data.
 * @valor: mês/ano do campo (MM/YYYY). Válido, abre no ano dele com o mês destacado; senão, abre no ano atual.
 * @anoMinimo / @anoMaximo: intervalo de ano permitido (as setas param nos limites)
 * @onSelect: chamada com o mês/ano escolhido (MM/YYYY)
 */
function SeletorMesAno({ valor, anoMinimo, anoMaximo, onSelect }) {
  const mesAnoAtual = fn_getMesAnoAtual();
  const mesAnoCampo = fn_validarMesAno(valor) ? valor : null;

  //### USE STATE ###
  const [ano, setAno] = useState(() =>
    Number((mesAnoCampo || mesAnoAtual).split("/")[1]),
  );

  //### FUNÇÕES ###
  //Mês/ano (MM/YYYY) do mês informado no ano apresentado
  function getMesAno(mes) {
    return `${String(mes).padStart(2, "0")}/${ano}`;
  }

  //Nome curto do mês (Jan, Fev...)
  function getNomeCurto(nome) {
    return nome.charAt(0) + nome.slice(1, 3).toLowerCase();
  }

  return (
    <div className="seletor-mesano">
      {/* Ano e as setas para trocar */}
      <div className="seletor-mesano-ano">
        <button
          type="button"
          title="Ano anterior"
          aria-label="Ano anterior"
          className="seletor-mesano-nav"
          onClick={() => setAno((prev) => prev - 1)}
          disabled={ano <= anoMinimo}
        >
          {ICONES_SETA.ANTERIOR}
        </button>

        <span>{ano}</span>

        <button
          type="button"
          title="Próximo ano"
          aria-label="Próximo ano"
          className="seletor-mesano-nav"
          onClick={() => setAno((prev) => prev + 1)}
          disabled={ano >= anoMaximo}
        >
          {ICONES_SETA.PROXIMO}
        </button>
      </div>

      {/* Meses: o do campo destacado e o mês atual em negrito */}
      <div className="seletor-mesano-meses">
        {fn_loadOpcoesMeses().map((mes) => {
          const mesAno = getMesAno(mes.value);

          return (
            <button
              key={mes.value}
              type="button"
              aria-label={`${mes.label} ${ano}`}
              className={"seletor-mesano-mes"
                .concat(mesAno == mesAnoCampo ? " selecionado" : "")
                .concat(mesAno == mesAnoAtual ? " atual" : "")}
              onClick={() => onSelect(mesAno)}
            >
              {getNomeCurto(mes.label)}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default SeletorMesAno;
